import { makeStyles } from '@mui/styles';

import Colors from 'configs/Colors';

const useStyles = makeStyles(() => ({
  paper: {
    border: `1px solid ${Colors.Grey3}`,
    borderRadius: 0,
    boxShadow: '0px 12px 16px rgba(16, 24, 40, 0.08), 0px 4px 6px rgba(16, 24, 40, 0.03)',
  },
  dialogHeader: {
    padding: 24,
  },
  dialogContent: {
    '&.MuiDialogContent-root': {
      padding: '0 24px 16px 24px',
    },
  },
  form: {
    display: 'flex',
    flexDirection: 'column',
    gap: 16,
  },
  fieldBlock: {
    display: 'flex',
    flexDirection: 'column',
    gap: 4,
  },
  labelRow: {
    display: 'flex',
    alignItems: 'center',
    gap: 4,
  },
  label: {
    fontFamily: 'Readex Pro',
    fontSize: 14,
    fontWeight: 200,
    lineHeight: '20px',
    letterSpacing: '0.56px',
    color: Colors.Grey10,
  },
  requiredMark: {
    fontFamily: 'Readex Pro',
    fontSize: 14,
    fontWeight: 200,
    lineHeight: '20px',
    letterSpacing: '0.56px',
    color: '#F5222D',
  },
  input: {
    '& .MuiOutlinedInput-root': {
      borderRadius: 0,
    },
    '& .MuiOutlinedInput-notchedOutline': {
      borderColor: Colors.Grey3,
    },
    '& .MuiInputBase-input': {
      fontFamily: 'Readex Pro',
      fontSize: 14,
      fontWeight: 200,
      lineHeight: '20px',
      letterSpacing: '0.56px',
      padding: '12px 8px',
    },
  },
  checkboxRow: {
    marginLeft: 0,
    marginRight: 0,
    gap: 8,
    alignItems: 'center',
  },
  checkboxLabel: {
    fontFamily: 'Readex Pro',
    fontSize: 16,
    fontWeight: 200,
    lineHeight: '24px',
    letterSpacing: '0.64px',
    color: '#323232',
  },
  dialogActions: {
    '&.MuiDialogActions-root': {
      padding: 24,
      borderTop: `1px solid ${Colors.Grey3}`,
      justifyContent: 'flex-end',
    },
  },
  submitButton: {
    '&.MuiButton-root': {
      backgroundColor: Colors.Black,
      borderRadius: 0,
      padding: 12,
      minWidth: 120,
      fontFamily: 'Readex Pro',
      fontSize: 16,
      fontWeight: 400,
      lineHeight: '24px',
      letterSpacing: '0.64px',
      color: Colors.White,
      textTransform: 'none',
      marginLeft: '0 !important',
      '&:hover': {
        backgroundColor: Colors.Black,
      },
      '&.Mui-disabled': {
        backgroundColor: Colors.Black,
        opacity: 0.4,
        color: Colors.White,
      },
    },
  },
}));

export default useStyles;
